import script from "./process_discount.vue?vue&type=script&setup=true&lang=js"
export * from "./process_discount.vue?vue&type=script&setup=true&lang=js"

import "./process_discount.vue?vue&type=style&index=0&id=7d814ee4&lang=css"

const __exports__ = script;

export default __exports__